import React, { useContext } from "react";
import { AppContext } from "../../components/States/AppContext";

//components
import SettingBar from "../../components/Settings/SettingBar";
import SettingMenu from "../../components/Settings/SettingMenu";
import SettingsDeviceMode from "../../components/Settings/SettingsDeviceMode";

//styles
import { SkWrapper } from "../../components/Settings/SmartKeyBox.elements";
import {
  ChangeWave,
  ChangeWave2,
} from "../../components/Settings/SettingsChangeWaves";

const Setting = ({ setting, index }) => {
  const { state, setState } = useContext(AppContext);

  if (setting.name1 === "devicemode") {
    return (
      <>
        <SkWrapper>
          <SettingBar setting={setting} key={index} />
          <SettingsDeviceMode setting={setting} key={index} />
        </SkWrapper>
      </>
    );
  } else if (setting.name1 === "changewave") {
    return (
      <>
        <ChangeWave />
      </>
    );
  } else if (setting.name1 === "changewave2") {
    return (
      <>
        <ChangeWave2 />
      </>
    );
  } else {
    return (
      <>
        <SkWrapper>
          <SettingBar setting={setting} key={index} />
          <SettingMenu setting={setting} key={index}  />
        </SkWrapper>
      </>
    );
  }
};

export default Setting;
